import React, { useState, useEffect, useRef } from "react";
import { CartesianGrid, XAxis, YAxis, LineChart, Line, ReferenceArea } from "recharts";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../ui/card";
import {
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from "../ui/chart";
import { ChartZoomControls, dayLabel, dayStart, useDailyChartZoom } from "./ChartZoom";

export const description = "An interactive bar chart";

export default function DetectionRadial(props) {
  const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
  
    useEffect(() => {
    if (props.startDate) {
      const d = new Date(props.startDate);
      // Formato “DD/MM/YYYY HH:mm”
      const formatted = d.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      setStartDate(formatted);
    }
  
      if (props.endDate) {
      const d = new Date(props.endDate);
      // Formato “DD/MM/YYYY HH:mm”
      const formatted = d.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      setEndDate(formatted);
    }
  }, [props.startDate, props.endDate]);

  const chartData = React.useMemo(() => {
    const data = (props.detections ?? []).map((detection) => {
      const ts = dayStart(detection?.timestamp);
      return { ts, date: dayLabel(ts, detection?.timestamp), value: detection?.nDetections || 0 };
    });
    return data.every((d) => Number.isFinite(d.ts)) ? data.sort((a, b) => a.ts - b.ts) : data;
  }, [props.detections]);

  const { visibleData, controls, dragHandlers, dragArea } = useDailyChartZoom(chartData);

  const chartConfig = {
    value: {
      label: "Value",
      color: "hsl(var(--chart-1))",
    },
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Detections</CardTitle>
        <CardDescription>
          {startDate === endDate ? `Showing total detections from ${startDate}`: `Showing total detections from ${startDate} to ${endDate}`}
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ChartZoomControls className="mb-3" {...controls} />
        <ChartContainer config={chartConfig} data-swapy-no-drag className="chart-zoomable aspect-auto h-[250px] w-full">
          <LineChart
            accessibilityLayer
            data={visibleData}
            {...dragHandlers}
            margin={{
              left: 0,
              right: 12,
              bottom: 15
            }}
          >
            <CartesianGrid vertical={false} />
            <XAxis
              className=""
              dataKey="date"
              tickLine={false}
              axisLine={false}
              tickMargin={8}
              minTickGap={8}
              label={{
                value: "Date (DD/MM)",
                position: "insideBottom",
                offset: -12.5,
                style: { textAnchor: "middle", fill: "#888"  }
              }}
            />
            <YAxis
              className="m-2 "
              tickLine={false}
              axisLine={false}
              tickMargin={20}
              ticks={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]} 

            />
            <ChartTooltip
              cursor={false}
              content={<ChartTooltipContent hideLabel />}
            />
            <Line
              dataKey="value"
              type="natural"
              stroke="var(--color-value)"
              strokeWidth={2}
              dot={{
                fill: "var(--color-value)",
              }}
              activeDot={{
                r: 6,
              }}
            />
            {dragArea?.start && dragArea?.end && (
              <ReferenceArea x1={dragArea.start.date} x2={dragArea.end.date} fillOpacity={0.12} strokeOpacity={0} />
            )}
          </LineChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}